import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SelectedDefaultBrand } from 'components/KBQSelect'

const initialState: SelectedDefaultBrand[] = []
const selectedDefaultKBQOptionsSlices = createSlice({
  name: 'SelectedDefaultKBQOptions',
  initialState,
  reducers: {
    setSelectedDefaultPurchasedBrand(state, action: PayloadAction<SelectedDefaultBrand>) {
      return state.filter(({ id }) => id !== action.payload.id).concat(action.payload)
    },
    removeSelectedPurchasedBrand(state, action: PayloadAction<{ id: string }>) {
      return state.filter(({ id }) => id !== action.payload.id)
    },
  },
})

export const { setSelectedDefaultPurchasedBrand, removeSelectedPurchasedBrand } =
  selectedDefaultKBQOptionsSlices.actions

export default selectedDefaultKBQOptionsSlices.reducer
